import React, {useContext, useMemo, useState} from 'react'
import {useWeb3React as useWeb3ReactCore} from '@web3-react/core'
import Web3 from 'web3'
import {Modal} from 'react-bootstrap';
import BaseBtn from '../../components/common/styled/BaseBtn'
import WhiteBtn from '../../components/common/styled/WhiteBtn'
import ModelBody from "../model/sub/ModelBody"
import BtnGroup from "../model/sub/BtnGroup"
import {createGlobalStyle} from 'styled-components';
import PropTypes from 'prop-types'
import {useAllowance, useBalance, useTransactionAdder} from "../../hooks";
import {ANTI_CONTACT_ADDRESS, TRIAS_DASHI_ADDRESS} from "../../web3/addresses";
import BigNumber from "bignumber.js";
import ANTIFRAUD from "../../web3/abi/antifraud.json";
import ERC20 from "../../web3/abi/ERC20.json"
import {getContract} from "../../web3";
import {mainContext} from "../../reducer";
import Loader from "../common/Loading";
import {numToWei} from "../../utils";
import {useAntiFraudStakingExist} from '../../hooks'
import {THIS_CHAIN_ID} from '../../const'

// const inputRegex = RegExp(`^\\d*(?:\\\\[.])?\\d*$`) // match escaped "." characters via in a non-capturing group

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

const GlobalStyle = createGlobalStyle`
  .InputAmountModel {
    .modal-dialog {
      max-width: 460px;
    }
    .input-notice {
      text-align: left;
      color: #333333;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      
      p:last-child {
        font-size: 14px;
      }
    }
    .input-box {
      padding: 0 25px;
      .input-box-item {
        display: flex;
        font-size: 16px;
        >input {
          width: calc(100% - 70px);
          border-radius: 6px;
          border: 1px solid #D2D2D2;
          padding: 0 12px;
        }
        >span {
          width: 60px;
          margin-left: 10px;
          display: inline-block;
          cursor: pointer;
          color: #fff;
          line-height: 34px;
          background: linear-gradient(270deg, #FF4CA1 0%, #FF017A 100%);
          border-radius: 6px;
        }
      }
      .error {
        color: rgba(255, 0, 0, 1);
        font-size: 12px;
        text-align: left;
      }
    }
  }
`

export default function InputAmountModel(props) {
  const {fromWei} = Web3.utils
  const addTransaction = useTransactionAdder()

  const {chainId, account, library} = useWeb3ReactCore()
  const balance = useBalance(TRIAS_DASHI_ADDRESS[chainId])
  const [amount, setAmount] = useState(10)

  const {transactions} = useContext(mainContext).state
  const approving = transactions.find((item) => {
    return (
        item.approve &&
        item.approve.status === 0 &&
        item.approve.account === account
    )
  })

  const staking = transactions.find((item) => {
    return (
        item.stake &&
        account === item.stake.account &&
        item.stake.status === 0
    )
  })

  const inputError = useMemo(() => {
    if (!balance || !amount) return false
    return new BigNumber(numToWei(amount)).isGreaterThan(balance)
  }, [balance, amount])

  const allowance = useAllowance(TRIAS_DASHI_ADDRESS[chainId], ANTI_CONTACT_ADDRESS[chainId])

  const approveStatus = useMemo(() => {
    if (!account || !amount) return true
    return !new BigNumber(numToWei(amount)).isGreaterThan(allowance)
  }, [account, allowance, amount])

  const stakingExist = useAntiFraudStakingExist();

  const onStake = async () => {
    try {
      const contract = getContract(
          library,
          ANTIFRAUD,
          ANTI_CONTACT_ADDRESS[chainId],
          account
      )

      if (!approveStatus) {
        const approveContract = getContract(
            library,
            ERC20,
            TRIAS_DASHI_ADDRESS[chainId],
            account
        )
        await approveContract
            .approve(
              ANTI_CONTACT_ADDRESS[chainId],
                '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
            )
            .then((response) => {
              //setHash(response.hash)
              addTransaction(response, {
                approve: {
                  account,
                  chainId,
                  status: 0,
                },
                summary: `Approve TRAIS`,
                hashLink: response.hash
              })
            })
        return
      }

      await contract
          .stake(numToWei(amount), {from: account})
          .then((response) => {
            // setAmount('')
            props.onHide()
            //setHash(response.hash)
            addTransaction(response, {
              stake: {
                status: 0,
                amount: amount,
                account
              },
              summary: `Deposite ${amount} TRAIS`,
              hashLink: response.hash,
            })

            // 捐赠成功？
            props.onSuccess();
          })
    } catch (e) {
      console.log('stake  error--->', e)
    }
  }

  return (
      <>
        <GlobalStyle></GlobalStyle>
        <Modal show={props.show}
               className="InputAmountModel"
               onHide={props.onHide}
        >
          <Modal.Body>
            <ModelBody>
              <div className="input-box">
                <div className="input-notice"><p>Amount</p><p>{balance ? `balance: ${fromWei(balance)}` : ''}</p>
                </div>
                <div className="input-box-item">
                  <input value="10" type="number" disabled/>
                </div>
                {inputError && <p className="error">Insufficient TRIAS Balance</p>}
                <span style={{fontSize: "16px",}}>{ stakingExist && 'You have Staked'}</span>
              </div>

            </ModelBody>
            <BtnGroup>
              <WhiteBtn width="150px" onClick={props.onHide} heigth="42px">Cancel</WhiteBtn>
              <BaseBtn disabled={!amount || new BigNumber(amount).isEqualTo(0) || stakingExist || approving || staking || inputError || !balance} width="150px" heigth="42px"
                       onClick={onStake}>
                {stakingExist ? 'Staked' : approveStatus ? staking ? 'Granting' : 'Confirm' : approving ? 'Approving' : 'Approve'}
                {(approving || staking) && chainId === THIS_CHAIN_ID && <Loader/>}
              </BaseBtn>
            </BtnGroup>
          </Modal.Body>
        </Modal>
      </>
  )
}

InputAmountModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
